(function() {
  'use strict';
  angular
    .module('webAgro1App')
    .directive('input', PreventWheelChangeDirective);

  function PreventWheelChangeDirective() {
    return {
      restrict: 'E',
      link: function(scope, element) {
        //Previne que o scroll do mouse altere os valores dos inputs do tipo number
        if (element[0].type === 'number') {
          element.on('wheel', function() {
            element[0].blur();
          });

          scope.$on('$destroy', function() {
            element.off('wheel');
          });
        }
      }
    };
  }
}());
